import React from 'react';
import { Alert, Typography } from '@mui/material';
import { Trans, useTranslation } from 'react-i18next';

function RoutePickupScheduleAlert({ routeType }) {
  const { t } = useTranslation(['description']);

  const boldComponent = <span style={{ fontWeight: 600 }} />;

  return (
    <Alert
      variant="outlined"
      severity="info"
      color="primary"
      sx={{
        my: 2,
      }}
    >
      <Typography color="primary" variant="body1" sx={{ fontWeight: 500 }}>
        {t('important', { ns: 'glossary' }).toUpperCase()}
      </Typography>
      <Typography color="primary" variant="body2" sx={{ fontSize: '14px' }}>
        <Trans
          t={t}
          i18nKey={`routes.info.type.${routeType}.pickup_schedule`}
          ns="description"
          components={[boldComponent, boldComponent, boldComponent]}
        />
      </Typography>
    </Alert>
  );
}

export default RoutePickupScheduleAlert;
